import React from "react"
import { Chip, ChipProps, Tooltip } from "@material-ui/core"

import { Color } from "@/protocols/color"

import { convertRGBAObjectToString } from "@/utils/color"
import { colors } from "@/styles/colors"

type TagChipProps = {
	name: string
	color: Color
	style?: React.CSSProperties
	tooltip?: {
		name: string
	}
	className?: string
}

const TagChip: React.FC<TagChipProps> = (props) => {
	const { color, name, style, tooltip, className, ...rest } = props

	if (tooltip) {
		return (
			<Tooltip title={tooltip.name} >
				<Chip
					label={name}
					style={{
						...style,
						backgroundColor: convertRGBAObjectToString(color),
						color: colors.gray[50]
					}}
					size="small"
					color="secondary"
					className={className}
					{...rest as ChipProps}
				/>
			</Tooltip>
		)
	} else {
		return (
			<Chip
				label={name}
				style={{
					...style,
					backgroundColor: convertRGBAObjectToString(color),
					color: colors.gray[50]
				}}
				size="small"
				color="secondary"
				className={className}
				{...rest as ChipProps}
			/>
		)
	}
}

export default TagChip
